import { Demographic, QueryParams } from '@/common/models';
import OrganizationType from '@/common/models/memberships/OrganizationType.enum';
import ErrorHandler from '@/ErrorHandler';
import ExchangeAppAPIProxy from '@/exch-app/api';
import OrgAppAPIProxy from '@/org-app/api';
import { queryKeys } from '@/org-app/services/tanstack/queryKeys';
import { createGetQuery, getOrganizationType } from '@/org-app/services/tanstack/queryUtils';
import orgAppStore from '@/org-app/store';
import { UPDATE_DEMOGRAPHICS_LIST } from '@/org-app/store/modules/referenceData/mutation-types';
import i18n from '@/vueI18n';

export const useDemographics = createGetQuery<Demographic>(
  [queryKeys.demographics],
  (queryParams: QueryParams) =>
    // For demographics, the consensus is to use the Org API for anything other than exchanges.
    getOrganizationType() === OrganizationType.EXCHANGE
      ? ExchangeAppAPIProxy.instance.getDemographics({ queryParams })
      : OrgAppAPIProxy.instance.getDemographics({ queryParams }),
  {
    mutation: (data: Demographic[]) => {
      orgAppStore.modules.ReferenceData.mutations[UPDATE_DEMOGRAPHICS_LIST](
        orgAppStore.modules.ReferenceData.state,
        data,
      );
    },
    onError(error) {
      const msg = i18n.global.t('messages.failedToGetDemographics');
      ErrorHandler.showError(msg, error);
    },
  },
);
